//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AddOption",1,0],[0,"AddToReferenceSet",1,0],[0,"ExcludeConnectors",1,0],[1,"ExcludeObjectSize",0,"Expression",0],[0,"ExcludeSmallObjects",1,0],[0,"IncludeAboveZ",1,0],[0,"SelectedRefSet",1,0],[0,"View",1,0]],[[[],"CalculateSelection",{},0,0],[[],"InvertSelection",{},0,0],[[],"ShowOnly",{},0,0],[[],"ShowAll",{},0,0]],[]];
SPLM.LineDesigner.SelectionToolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.SelectionToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.SelectionToolBuilder.SelectionView = Object.freeze({
    "SixStandard" : "SixStandard", "EightIsometric" : "EightIsometric", "AllFourteen" : "AllFourteen"});

SPLM.LineDesigner.SelectionToolBuilder.RefSetOption = Object.freeze({
    "Add" : "Add", "Replace" : "Replace"});

export default SPLM;